module.exports = __webpack_public_path__ + "media/images/icon_edit-da16a1f59ef6168d9c5a93a91f11c1dc.svg";